/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE.
*/

import { forwardRef } from "react";

import { css, cx } from "@panda/css";

import { CosmosClickableBox, CosmosLink } from "../";

import type { CosmosLinkProps } from "../../";

export type CosmosCardLinkProps = CosmosLinkProps & {
	clickableCard?: boolean;
};

const cardLinkStyles = css({
	outline: "none",
});

export const CosmosCardLink = forwardRef(
	(
		{ children, className, clickableCard = true, ...props }: CosmosCardLinkProps,
		forwardedRef: React.Ref<HTMLAnchorElement>,
	): React.JSX.Element => {
		return clickableCard ? (
			<CosmosClickableBox.Link
				{...props}
				className={cx("cosmos-card__link", cardLinkStyles, className)}
				ref={forwardedRef}
			>
				{children}
			</CosmosClickableBox.Link>
		) : (
			<CosmosLink {...props} className={cx("cosmos-card__link", className)} ref={forwardedRef}>
				{children}
			</CosmosLink>
		);
	},
);

CosmosCardLink.displayName = "CosmosCard.Link";
